import Typography from "@mui/material/Typography";

import ConfigurationModel from "src/models/ConfigurationModel";
import NoAccessToFTP from "src/newComponents/NoAccessToFTP";

import RegisterForSessions from "./RegisterForSessions";

interface LiveOnlineStudySessionsTopSectionProps {
  userHasAccess: boolean;
  configurations: ConfigurationModel[];
}

const LiveOnlineStudySessionsTopSection = ({
  userHasAccess,
  configurations,
}: LiveOnlineStudySessionsTopSectionProps) => {
  return (
    <>
      <Typography sx={{ margin: "1rem 0" }}>
        We're known to be the training provider who delivers the most interactive teaching sessions throughout the
        Foundation Pharmacist Training Year. This is really important to give you structured support throughout your
        training year.
      </Typography>
      <Typography sx={{ margin: "1rem 0" }}>
        With over 50 opportunities to cover key topics including discussing the questions in the workbooks with answers,
        exam revision courses, case studies, Q&A sessions, revision updates, motivation and more.
      </Typography>

      <Typography sx={{ margin: "1rem 0" }}>
        Can't attend live or enrolling later/missed webinars? No problem! You'll have access to all the live study
        sessions webinars as recordings to watch later at your convenience.
      </Typography>

      <Typography sx={{ margin: "1rem 0", fontStyle: "italic" }}>
        Joining the live webinars and watching the recording is only available to anyone enrolled on the Foundation
        Pharmacist Training Programme only.
      </Typography>

      <Typography sx={{ margin: "1rem 0" }}>
        Select Zoom Register for Live Sessions to register and join us live on the day.
      </Typography>

      {userHasAccess && <RegisterForSessions configurations={configurations} />}
      {!userHasAccess && <NoAccessToFTP accessToText="Live Online Study Sessions" />}
    </>
  );
};

export default LiveOnlineStudySessionsTopSection;
